module.exports = {"id":"187366","name":"Denis Glushakov","rating":"78","photo":"./data/images/photos/1/187366.png","club":{"name":"Spartak Moscou","logo":"./data/images/clubs/SpartakMoscou.png"},"positions":["MDC","MC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DenisGlushakov0.json
// module id = 1047
// module chunks = 0